import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
export var injectOrganizationId = function injectOrganizationId(to, orgId) {
    var _to_pathname;
    return typeof to === 'string' ? injectOrg(to, orgId) : _object_spread_props(_object_spread({}, to), {
        pathname: injectOrg((_to_pathname = to.pathname) !== null && _to_pathname !== void 0 ? _to_pathname : '', orgId)
    });
};
var injectOrg = function injectOrg(path, orgId) {
    if (isScopedToOrg(path, orgId) || // Don't prepend the orgId if it's already there
    !path.startsWith('/') // Don't prepend the ordId if it's a relative path
    ) {
        return path;
    }
    return "/".concat(orgId).concat(path);
};
var isScopedToOrg = function isScopedToOrg(path, orgId) {
    var orgRoot = "/".concat(orgId);
    return path === orgRoot || [
        '/',
        '?',
        '#'
    ].some(function(separator) {
        return path.startsWith("".concat(orgRoot).concat(separator));
    });
};

//# sourceMappingURL=injectOrganizationId.js.map